module.exports = __webpack_public_path__ + "img/altamira.d4261296.png";